const bookmarkSubtle = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path stroke-width="1.5" d="M3.75 1.75v11.723l4.26-3.291 4.24 3.287V1.75z"/></svg>',
};

export { bookmarkSubtle as default };
